/**
 * @generated SignedSource<<fbc77608ea2c8f02ed49b8064ac21c98>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Branch = "adviceAndConsulting" | "analysisAndStatistic" | "financeAccountingAndControlling" | "graphicsAndDesign" | "healthMedicineAndSocialAffairs" | "itAndSoftwareDevelopment" | "legalServices" | "marketingAndAdvertising" | "otherFieldsOfActivity" | "personnelAndHr" | "processPlanningAndQualityAssurance" | "productManagement";
export type TeamSize = "fiftyToHundred" | "oneToTen" | "overHundred" | "tenToTwentyFive" | "twentyFiveToFifty";
export type RegisterUserInput = {
  adsOptIn: boolean;
  branch?: Branch | null;
  clientMutationId?: string | null;
  email: string;
  firstName: string;
  lastName: string;
  position?: string | null;
  potentialAnalysisRegistrationData?: PotentialAnalysisRegistrationDataInput | null;
  rawPassword: string;
  teamSize?: TeamSize | null;
};
export type PotentialAnalysisRegistrationDataInput = {
  language: string;
  ptt: number;
  pttchk: string;
  rvw: number;
  rvwchk: string;
};
export type useAuthContext_RegisterMutation$variables = {
  input: RegisterUserInput;
};
export type useAuthContext_RegisterMutation$data = {
  readonly Auth: {
    readonly registerUser: {
      readonly userId: string;
    } | null;
  };
};
export type useAuthContext_RegisterMutation = {
  response: useAuthContext_RegisterMutation$data;
  variables: useAuthContext_RegisterMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AuthMutations",
    "kind": "LinkedField",
    "name": "Auth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "RegisterUserPayload",
        "kind": "LinkedField",
        "name": "registerUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAuthContext_RegisterMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAuthContext_RegisterMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c5ef0a90c980cf7a401450df8a47de6d",
    "id": null,
    "metadata": {},
    "name": "useAuthContext_RegisterMutation",
    "operationKind": "mutation",
    "text": "mutation useAuthContext_RegisterMutation(\n  $input: RegisterUserInput!\n) {\n  Auth {\n    registerUser(input: $input) {\n      userId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d7341094365baa34c0c66261c795a678";

export default node;
